import type { Pixel } from "@pdfking/math"
import type { PDFRasterizeFunction } from "@pdfking/renderer-api"
import {
  BlobArray,
  BlobToUint8,
  ExportImage,
  UrlLoad,
} from "@pdfking/compatibility"
import { ProvisionWasm } from "@pdfking/ghostscript"
import { PSOcoated_v3_small as DefaultICC } from "@pdfking/icc"
import { IterableToArray } from "@pdfking/tfunc"

export const PDFRasterize: PDFRasterizeFunction = (input, dpi = 72 as Pixel) =>
  ProvisionWasm(async function* (api) {
    const [data, icc] = await Promise.all([
      IterableToArray(input.stream).then(BlobArray).then(BlobToUint8),
      UrlLoad(input.icc ?? DefaultICC).then(r => r.bytes()),
    ])

    const { value: result, error } = await api.rasterize_page({
      data,
      dpi,
      icc,
    })
    if (error) throw error

    const { width, height, bytes } = result
    const blob = await ExportImage({
      data: bytes,
      width,
      height,
    })

    yield {
      blob,
      page: result.page,
      width,
      height,
    }
  })
